const BoldText = (props) =>{
    const {children} = props
    return <a className="font-bold text-white">{children}</a>
}

export default BoldText